module.exports = __webpack_public_path__ + "img/contact.18ca2de5.svg";